import { eventComponentNoEnum } from '../events/events.schemas';
import { EVENT_TYPES, validationSchema } from '../../types';
import * as z from 'zod/v4';

const templateBaseSchema = z.object({
  id: z.string(),
  name: z.string(),
  eventType: z.enum(EVENT_TYPES).optional(),
  createdAt: z.coerce.date(),
  lastUpdatedAt: z.coerce.date(),
  lastModifiedBy: z.object({
    name: z.string(),
    email: z.string(),
  }),
});

export const templateSchema = templateBaseSchema.and(eventComponentNoEnum);

export const getTemplatesQuery = z.object({
  search: z.string().optional(),
  page: z.coerce.number().optional(),
  pageSize: z.coerce.number().optional(),
  eventType: z.enum(EVENT_TYPES).optional(),
});

export const createTemplateBaseSchemaBody = templateBaseSchema.pick({
  name: true,
});

export const createTemplateSchemaBody = createTemplateBaseSchemaBody.and(eventComponentNoEnum);

export const updateTemplateSchemaBody = createTemplateBaseSchemaBody
  .partial()
  .and(eventComponentNoEnum);

export const createTemplateSchema = validationSchema({
  body: createTemplateSchemaBody,
  response: {
    200: z.object({
      template: templateBaseSchema.omit({ lastModifiedBy: true }).and(eventComponentNoEnum),
    }),
    500: z.object({
      message: z.string(),
    }),
  },
});

export const updateTemplateSchema = validationSchema({
  body: updateTemplateSchemaBody,
  params: z.object({
    id: z.string(),
  }),
  response: {
    200: z.object({
      template: templateBaseSchema.omit({ lastModifiedBy: true }).and(eventComponentNoEnum),
    }),
    404: z.object({
      message: z.string(),
    }),
    500: z.object({
      message: z.string(),
    }),
  },
});

export const deleteTemplateSchema = validationSchema({
  params: z.object({
    id: z.string(),
  }),
  response: {
    204: z.void(),
    404: z.object({
      message: z.string(),
    }),
    500: z.object({
      message: z.string(),
    }),
  },
});

export const getTemplateSchema = validationSchema({
  params: z.object({
    id: z.string(),
  }),
  response: {
    200: z.object({
      template: templateSchema,
    }),
    404: z.object({
      message: z.string(),
    }),
    500: z.object({
      message: z.string(),
    }),
  },
});

export const getTemplatesSchema = validationSchema({
  querystring: getTemplatesQuery,
  response: {
    200: z.object({
      templates: z.array(templateSchema),
      total: z.number(),
      totalPages: z.number(),
    }),
    500: z.object({
      message: z.string(),
    }),
  },
});
